import { gql } from "@apollo/client";
import { Exhibition as exhibition } from "../fragments";

const FETCH_EXHIBITION = props => gql`
  query FetchExhibition($id: Int) {
    exhibition(id: $id) {
      ${exhibition(props)}
    }
  }
`;

const FETCH_EXHIBITIONS = props => gql`
  query FetchExhibitions($input: ExhibitionFilterInput) {
    exhibitions(input: $input) {
      count
      edges {
        ${exhibition(props)}
      }
    }
  }
`;

const FETCH_EXHIBITIONS_V2 = props => gql`
  query FetchExhibitionsV2($input: AdvExhibitionFilterInput!) {
    exhibitionsV2(input: $input) {
      count
      edges {
        ${exhibition(props)}
      }
      sqlQuery
    }
  }
`;

const FETCH_EXHIBITIONS_LIST = gql`
  query FetchExhibitionsV2($input: AdvExhibitionFilterInput!) {
    exhibitionsV2(input: $input) {
      count
      edges {
        id
        contact {
          company
          name
        }
        endDay
        endMonth
        endYear
        startDay
        startMonth
        startYear
        title
      }
    }
  }
`;

/**
 * Lazy resolver: only the synopsis is requested, so the underlying
 * `Exhibition.findAll` returns at most one row. Used by the breadcrumb
 * root and the report modal to surface the human-readable filter
 * description matching what's currently selected.
 */
const FETCH_EXHIBITIONS_SEARCH_SYNOPSIS = gql`
  query FetchExhibitionsSearchSynopsis($input: AdvExhibitionFilterInput!) {
    exhibitionsV2(input: $input) {
      searchSynopsis
    }
  }
`;

export {
  FETCH_EXHIBITION,
  FETCH_EXHIBITIONS,
  FETCH_EXHIBITIONS_V2,
  FETCH_EXHIBITIONS_LIST,
  FETCH_EXHIBITIONS_SEARCH_SYNOPSIS,
};
